export default __webpack_public_path__ + "static/media/icon_market_active.257003dd.svg";